export type DebugLogType = "request" | "response" | "error";

export type DebugLogEntry = {
	id: string;
	timestamp: Date;
	type: DebugLogType;
	method?: string;
	url: string;
	status?: number;
	headers?: Record<string, string>;
	body?: unknown;
	duration?: number;
};

class DebugBus extends EventTarget {
	private subscriberCount = 0;

	emitLog(log: DebugLogEntry) {
		if (this.subscriberCount > 0) {
			this.dispatchEvent(new CustomEvent("debug-log", { detail: log }));
		}
	}

	subscribe(callback: (log: DebugLogEntry) => void) {
		const handler = (event: Event) => {
			const customEvent = event as CustomEvent<DebugLogEntry>;
			callback(customEvent.detail);
		};
		this.addEventListener("debug-log", handler);
		this.subscriberCount++;
		return () => {
			this.removeEventListener("debug-log", handler);
			this.subscriberCount--;
		};
	}

	get isActive() {
		return this.subscriberCount > 0;
	}
}

export const debugBus = new DebugBus();
